import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import CanvasCharacter from './CanvasCharacter/CanvasCharacter';
import classes from './Characters.module.css';

import clsx from 'clsx';
import { FaForward, FaPause, FaPlay } from 'react-icons/fa6';
import { Dial } from '../../js/Dials';
import SoundPlayer from 'react-sdk/SoundPlayer';
import Button from '../shared/Button/Button';
import Texts from 'react-sdk/Texts';


const Characters = ({dials}) => {
  const [paused, setPaused] = useState(false);

  const loading = dials.loading

  /** @type {Dial} */
  const dial = dials.currentDial
  if(!dial) return
  console.log("dial", dial)
  //const dialBG = dial.element.line.get("bg")
  const dialAudio = dial.element.line.get("Audio")
  const dialText = dial.element.line.get("Text")
  const char = dial.element.line.get("Character")

  const characterIds = Array.from(dials.loadedCharIds)

  if(dial.element.isChoice())
    SoundPlayer.playSound("dial_choice")
  else
    SoundPlayer.playSound("dial_pop")

  /*useEffect(() => {

    dialBG = dial.element.line.get("bg")
    dialAudio = dial.element.line.get("Audio")
    dialText = dial.element.line.get("Text")
    dialType = dial.element.line.get("Type")

      return () => { }



    }, []);*/


  function togglePause(e){
    e.stopPropagation()
    if(paused) {
      charRef.current.resume()
    }
    else {
      charRef.current.pause()
    }

    setPaused(p => !p)
  }


  function handleSkip(e) {
    e.stopPropagation()

    const Audio = dial.element.line.get("Audio")

    if(!Audio) {
      dials.nextDial()
      // onEnd && onEnd();
    }
    else {
      dial.charRef.current.skipSegment()
    }
  }

  console.log("characterIds", characterIds)
  return (

    <div className={clsx(classes.Characters, "Characters")}>

      {dial &&
      <>
        <CanvasCharacter char_id={char} dial={dial} loading={loading} onEnd={()=>dials.nextDial()} key={char} />)
        {/* {characterIds &&
        dial.map(id => (
        )} */}

      </>}

      {!dial.element.isChoice() && dial?.subtitle &&
      <div className={clsx(classes.subtitle, "subtitle")} onClick={handleSkip}>
        <div className={clsx(classes.char_name, "char_name")}>{Texts.get(char)}</div>
        <div className={clsx(classes.subtitle_text, "subtitle_text")} dangerouslySetInnerHTML={{__html: dial.subtitle}} />

        <FaForward className={clsx(classes.forward, "forward")} />

        {/*dialAudio &&
        <div
        className={clsx(classes.pauseButton, "pauseButton")}
        onClick={togglePause}
        >
          {paused ? <FaPlay /> : <FaPause />}
        </div>*/}
      </div>}


      {dial.element.isChoice() &&
        <div className={clsx(classes.choices, "choices")}>
          <div className={clsx(classes.choice_title, "choice_title")}>
            {dialText}
          </div>
          <div className={clsx(classes.choice_buttons, "choice_buttons")}>
            {dial.element.choices.map(choice => {
              return (
              <Button className={clsx(classes.choice_btn, "choice_btn")} key={choice.id} onClick={() => {
                dial.element.addAnswer(choice.getId())
                dials.nextDial()
                SoundPlayer.playSound("dial_answer")
              }}>
                {choice.line.get("Text")}
              </Button>)
            })}
          </div>
        </div>}

      {/* {loading &&
      <div className={clsx(classes.dial_loading, "dial_loading")}>
        <Loader />
      </div>} */}

    </div>



  );
};

export default observer(Characters)
